var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoLine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 1917 279",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2",
    "data-name": "Rect\\xE1ngulo 2",
    width: 254,
    height: 254,
    transform: "translate(0 -0.065)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo-secundary-white",
    transform: "translate(-312 -288.286)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "C_Y_Innovation",
    "data-name": "C&Y Innovation",
    transform: "translate(1418 499.286)",
    fill: "#5d6d7e",
    fontSize: 217,
    fontFamily: "MarcellusSC-Regular, Marcellus SC"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -810.465,
    y: 0
  }, "\r\n        C&amp;Y Innovation\r\n      ")), /*#__PURE__*/React.createElement("g", {
    id: "Enmascarar_grupo_2",
    "data-name": "Enmascarar grupo 2",
    transform: "translate(312 313.351)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vec-triangulo",
    transform: "translate(0.914 18.393)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3",
    "data-name": "Trazado 3",
    d: "M210.321,72.876c-.347.652-.652,1.3-1,1.911Q194.6,100.849,179.785,126.52l-51.559,90.217a3.607,3.607,0,0,0-.3.565c-1.173,2.042-1.433,2.042-2.563,0l-12.075-21.2c-7.819-13.682-15.68-27.365-23.456-41.047-2.128-3.779-2.172-2.78.738-5.777l42.307-42.915Q153.2,85.776,173.748,65.188a4.344,4.344,0,0,1,4.821-1.347c9.99,2.78,20.024,5.386,30.058,8.079a1.61,1.61,0,0,1,1.694.956ZM38.314.033H73.844A3,3,0,0,1,77.363,2.64Q92.913,58.8,108.593,114.922a3.431,3.431,0,0,1-1.042,3.909Q95.562,130.342,83.922,142.2c-1.433,1.433-1.911,1.086-2.823-.478Q47.783,83.6,13.989,25.444,7.474,14.172.959,2.857C-.562.294-.431.033,2.479.033Zm131.09,0h80.618c1.868,0,2,.695,1.173,2.128L240.552,20.579c-8.166,14.2-16.332,28.1-24.455,42.22-.869,1.564-1.737,1.737-3.388,1.3Q155.2,48.421,97.517,32.828a4.344,4.344,0,0,1-3.562-3.518c-2.128-8.687-4.344-17.635-6.776-26.5-.652-2.563-.3-2.78,2.215-2.78Z",
    transform: "translate(0.001 0.016)",
    fill: "#01ade8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4",
    "data-name": "Trazado 4",
    d: "M32.572,14.049l1.129.3Q64.106,22.3,94.512,30.164c2.041.521,1.607,1.173.521,2.3-5.125,5.343-10.338,10.685-15.767,16.115Q65.409,62.741,51.423,76.815c-1.737,1.781-1.868,1.737-2.519-.652q-8.3-29.971-16.506-59.9C32.224,15.526,31.4,14.527,32.572,14.049Z",
    transform: "translate(67.336 29.653)",
    fill: "#5d6d7e"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLine);
export default __webpack_public_path__ + "static/media/logo-line.eec0a6c78aec42b43038ea364949d2b2.svg";
export { ForwardRef as ReactComponent };